import styled from "styled-components";

export const InitialNoDataContainer = styled.div`
  text-align: center;
  margin-top: 100px;
`;
